import { isEmpty, isEqual, isString } from 'lodash';
import { EditableField, Field } from './Field';

interface TextFieldOptions {
  multiline?: boolean | null;
}

export class TextField implements EditableField {
  readonly value: string;
  readonly fieldType = 'TextField';
  readonly multiline: boolean;

  constructor(jsonBlob: any, options: TextFieldOptions = {}) {
    this.value = jsonBlob;
    this.multiline = Boolean(options.multiline);
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof TextField && isEqual(this.value, field.value);
  }

  toFieldJson() {
    return this.value;
  }

  toDisplayString(): string {
    return this.value;
  }

  get isEmpty() {
    return isEmpty(this.value.trim());
  }

  static fromFieldJson(jsonBlob: any, options: TextFieldOptions): TextField | null {
    if (isString(jsonBlob)) {
      return new TextField(jsonBlob, options);
    } else {
      return null;
    }
  }
}
